/**
 * @module sagas/Routing.js
 * Anything related to routes and urls
 */
import { push } from 'react-router-redux';
import { put, take } from 'redux-saga/effects';

import * as Constants from '../constants';

import { taskManagerSpawnFactory } from './Helpers/SpawnedTaskManager';

const spawn = taskManagerSpawnFactory();
const LOOP = true;

function* watchReroute() {
  while (LOOP) {
    const action = yield take(Constants.App.AppActions.REROUTE);
    yield put(push(action.payload.path));
  }
}

export default function* routingSaga() {
  yield spawn(watchReroute);
}
